<!-- eslint-disable vue/multi-word-component-names -->
<script>
import AppPageContainer from '@/components/app/PageContainer.vue';
import Description from '@/components/Qc/CheckList/Details/description.vue';
import SharedMixin from '@/Mixins/Shared';
import ChecklistDetailsMixin from '@/Mixins/BaseInformation/ChecklistDetails.mixin';
import checklistDetailsHelper from '@/Helpers/BaseInformation/checklist/checklistDetails.helper';
import ChecklistDTO from '@/Helpers/BaseInformation/checklist/checklist.dto';
export default {
  title: 'جزییات فرم',
  inject: ['load'],
  mixins: [SharedMixin, ChecklistDetailsMixin, checklistDetailsHelper, ChecklistDTO],
  components: {
    AppPageContainer,
    Description,
  },
  created() {
    this.$root.$refs.qcCheckListDetails = this;
  },
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      const id = +this.$route?.params?.id;
      this.getCheckListDetails(id);
    },
  },
  computed: {
    allCheckLists: function () {
      return [
        {
          id: 0,
          title: 'اطلاعات اولیه و توضیحات',
          component: Description,
          details: this.descriptionDetails,
        },
        ...this.checkLists.tabs,
      ];
    },
  },
};
</script>
<template>
  <app-page-container title="جزئیات فرم">
    <template #header>
      <v-col cols="1" class="mt-4 mr-n12">
        <v-btn fab small dark color="darkColor" @click="$router.back()">
          <v-icon>mdi-arrow-right mdi-24px</v-icon>
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="10" class="mt-4">
        <v-tabs color="darkColor" @change="onChange" v-model="currentChecklist">
          <v-tab v-for="{ id, title } in allCheckLists" :key="id" class="normal-letter-spacing">
            {{ title }}
          </v-tab>
        </v-tabs>
      </v-col>
      <v-spacer></v-spacer>
    </template>
    <template #body>
      <v-card elevation="0">
        <v-card-text tag="section" class="px-8 pt-4">
          <keep-alive>
            <component v-bind:is="allCheckLists[currentChecklist]?.component"
              v-bind:details="allCheckLists[currentChecklist]?.details"></component>
          </keep-alive>
        </v-card-text>
      </v-card>
    </template>
  </app-page-container>
</template>
